import { render, staticRenderFns } from "./userspecialdiet.vue?vue&type=template&id=7b5cd36c&"
import script from "./userspecialdiet.vue?vue&type=script&lang=js&"
export * from "./userspecialdiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports